import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Users } from 'lucide-react';
import logo from '../../assets/logo.png';

const RoleSelect: React.FC = () => {
  const navigate = useNavigate();

  const handleRoleSelect = (role: 'client' | 'expert') => {
    localStorage.setItem('authRole', role);

    // Navigate to login page for selected role
    if (role === 'client') {
      navigate('/client/login');
    } else {
      navigate('/expert/login');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 flex flex-col p-4">
        {/* Logo - centered between top and cards */}
        <div className="flex-1 flex items-center justify-center">
          <img src={logo} alt="BookDay" className="h-12 w-auto" />
        </div>

        {/* Cards in the middle */}
        <div className="w-full max-w-md mx-auto space-y-4">
          {/* Client Card - horizontal layout for mobile */}
          <button
            onClick={() => handleRoleSelect('client')}
            className="group w-full bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-5 text-left border-2 border-transparent hover:border-purple-400 focus:outline-none focus:ring-4 focus:ring-purple-200"
            aria-label="Continue as Client"
          >
            <div className="flex items-center gap-4">
              <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 bg-purple-100 rounded-xl group-hover:bg-purple-200 transition-colors">
                <Users className="w-7 h-7 text-purple-600" />
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="text-xl font-bold text-gray-900">
                  I'm a Client
                </h2>
                <p className="text-sm text-gray-600 mt-1">
                  Book services for yourself
                </p>
              </div>
              <svg className="w-5 h-5 text-purple-600 group-hover:translate-x-1 transition-transform flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </button>

          {/* Expert Card - horizontal layout for mobile */}
          <button
            onClick={() => handleRoleSelect('expert')}
            className="group w-full bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-5 text-left border-2 border-transparent hover:border-pink-400 focus:outline-none focus:ring-4 focus:ring-pink-200"
            aria-label="Continue as Expert"
          >
            <div className="flex items-center gap-4">
              <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 bg-pink-100 rounded-xl group-hover:bg-pink-200 transition-colors">
                <Calendar className="w-7 h-7 text-pink-600" />
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="text-xl font-bold text-gray-900">
                  I'm an Expert
                </h2>
                <p className="text-sm text-gray-600 mt-1">
                  Manage your schedule and bookings
                </p>
              </div>
              <svg className="w-5 h-5 text-pink-600 group-hover:translate-x-1 transition-transform flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </button>
        </div>

        {/* Footer - centered between cards and bottom */}
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center text-xs text-gray-500">
            <p>By continuing, you agree to our</p>
            <p>
              <a href="/terms" className="text-purple-600 hover:underline">
                Terms of Service
              </a>
              {' & '}
              <a href="/privacy" className="text-purple-600 hover:underline">
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
    </div>
  );
};

export default RoleSelect;
